@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  display: inline-block;
  width: auto;
  box-sizing: border-box;
  --datepicker-width: 296px;
  --datepicker-height: 185px;
  --timerange-select-width: 178px;
}

gz-date-range-picker {
  --date-range-inputs-spacing: calc(2 * var(--spacer)) calc(7 * var(--spacer)) var(--spacer) calc(7 * var(--spacer));
  --wrapper-spacing: 0 calc(7 * var(--spacer));
  --actions-spacing: calc(2 * var(--spacer)) calc(7 * var(--spacer));
}

.filter {
  display: flex;
  flex-direction: row;

  &--timerange-select {
    min-width: var(--timerange-select-width);
    padding: calc(1.5 * var(--spacer)) var(--spacer) calc(2 * var(--spacer)) calc(2 * var(--spacer));
    gz-radio {
      height: calc(4 * var(--spacer));
      margin-bottom: 0;
      display: flex;
      align-items: center;
    }
  }

  &--datepicker {
    border-left: 1px solid var(--chart-100-pressed);
  }

  &--calendar {
    position: relative;
  }
}
